import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

export const GET_TRANSACTION = gql`
  query GetTrackTransaction($purchase_id: Int!) {
    getTrackTransaction(purchase_id: $purchase_id) {
      id
      fee
      original_fee
      subtotal
      total
      original_total
      profit
      refund
      discount
      credit
      transfer_id
      charge_id
      show_fee
      card {
        last4
      }
      purchase_date
      status
      promos
      refunded
      credited
      user {
        id
        name
        first_name
        last_name
        formatted_name
      }
      users {
        promo
        user {
          id
          name
          first_name
          last_name
        }
        tickets {
          id
          name
          price
          refunded
          credited
          type
          barcode
          section
          row
          seat
          date
          seat_id
          reserved_seat_prefix
          reserved_seat_section
          scan_logs {
            type
            status
            created_at
            raw_created_at
            scanner {
              first_name
              last_name
            }
          }
          bundle_children {
            id
            name
            date
            barcode
            scan_logs {
              type
              status
              created_at
              raw_created_at
              scanner {
                first_name
                last_name
              }
            }
          }
        }
      }
      international_fee
      order_source
      payment_method
      delivery_method
      register
      credits_issued
      refunded_amount
      credits {
        id
        created_at
        created_by {
          first_name
          last_name
        }
        amount
        original_amount
        reason
      }
      refunds {
        id
        created_at
        created_by {
          first_name
          last_name
        }
        amount
        reason
      }
      event {
        name
        start_date
        pos_settings {
          ticket_delivery
          receipt_delivery
        }
      }
      track {
        name
      }
    }
  }
`;

export function useGetTrackTransaction(id, fetch) {
  return useQuery(GET_TRANSACTION, {
    variables: {
      purchase_id: Number(id),
    },
    skip: !fetch || !id,
    fetchPolicy: 'no-cache',
  });
}
